import { FCC, LocaleProvider } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ProductTranslationsProvider } from "./i18n/ProductTranslationsProvider";

interface Props {
	locale?: string;
	timeZone?: string;
}

export const JarvisLocaleProvider: FCC<Props> = ({
	children,
	timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
	locale = Intl.DateTimeFormat().resolvedOptions().locale,
}) => {
	const queryClient = useQueryClient();

	const changeLanguage = (newLanguage: string) => {
		void i18n.changeLanguage(newLanguage);
		axios.defaults.headers["Content-Language"] = newLanguage;
		void queryClient.invalidateQueries();
	};

	return (
		<I18nextProvider i18n={i18n}>
			<ProductTranslationsProvider />
			<LocaleProvider
				initialLanguage={locale}
				initialTimeZone={timeZone}
				initialFormatLocale={locale}
				onChange={changeLanguage}
			>
				{children}
			</LocaleProvider>
		</I18nextProvider>
	);
};
